import createLucideIcon from '../createLucideIcon';

const FileSearch2 = createLucideIcon('FileSearch2Icon', [
  [
    'path',
    {
      d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z',
      key: '1nnpy2',
    },
  ],
  ['polyline', { points: '14 2 14 8 20 8', key: '1ew0cm' }],
  ['circle', { cx: '11.5', cy: '14.5', r: '2.5', key: '1bq0ko' }],
  ['path', { d: 'M13.25 16.25 15 18', key: '9eh8bj' }],
]);

export default FileSearch2;
